import React from 'react'
import PropTypes from 'prop-types'

const OrgKeyStatus = ({ keys }) => {
  const safeKeys = Array.isArray(keys) ? keys : []

  if (safeKeys.length === 0) {
    return <span className="label label-default">No Keys</span>
  }

  const hasEnabled = safeKeys.some(k => k.enabled)

  return hasEnabled ? (
    <span className="label label-success">Enabled</span>
  ) : (
    <span className="label label-default">Disabled</span>
  )
}

OrgKeyStatus.propTypes = {
  keys: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      key: PropTypes.string,
      secret: PropTypes.string,
      enabled: PropTypes.bool,
    })
  ),
}

export default OrgKeyStatus
